import { template } from "@ember/template-compiler";
import { service } from '@ember/service';
import BalanceBanner from 'client-portal/components/site/billing/balance-banner';
import BillingAndPaymentsTabs from 'client-portal/components/site/billing/billing-and-payments-tabs';
import BillingPage from 'client-portal/components/site/billing-page';
import Component from '@glimmer/component';
import Container from 'client-portal/components/layout/container';
import ExternalBillingBanner from 'client-portal/components/site/billing/external-billing-banner';
import PageTitle from 'client-portal/components/site/page-title';
import TransferSetupBanner from 'client-portal/components/site/billing/transfer-setup-banner';
import t from 'ember-intl/helpers/t';
const EXTERNAL_BILLING_BANNER_KEY_SEGMENTS = [
    'header',
    'body',
    'ctaLink',
    'cta'
];
export default class SiteBillingBillingAndPaymentsTab extends Component {
    @service
    billingTransfer;
    @service
    intl;
    get showExternalBillingBanner() {
        return (this.args.client?.latestChannelHasBillingBannerEnabled && this.isChannelEnrollmentCompleted && !this.billingTransfer.isPendingTransfer);
    }
    get isChannelEnrollmentCompleted() {
        let channelName1 = this.args.client?.latestChannelName;
        let enrollment1 = this.args.client?.monarchChannelClientInfos?.find((info1)=>info1.globalMonarchChannel?.name === channelName1);
        return enrollment1?.enrollmentStatus === 'completed';
    }
    get channelBannerText() {
        let channelName1 = this.args.client?.latestChannelName;
        let bannerText1 = {};
        let missingKeys1 = [];
        EXTERNAL_BILLING_BANNER_KEY_SEGMENTS.forEach((segment1)=>{
            let key1 = `channel-specific.${channelName1}.externalBillingBanner.${segment1}`;
            if (this.intl.exists(key1)) {
                bannerText1[segment1] = this.intl.t(key1);
            } else {
                missingKeys1.push(segment1);
            }
        });
        if (missingKeys1.length > 0) {
            // eslint-disable-next-line no-console
            console.error(`Missing translations for external billing banner sections (channel: ${channelName1}):`, missingKeys1);
            return null;
        }
        return bannerText1;
    }
    static{
        template(`
    <BillingPage>
      <PageTitle @title={{t "billing.pageTitle"}} />
      <Container>
        <TransferSetupBanner />
        {{#if this.showExternalBillingBanner}}
          {{#let this.channelBannerText as |bannerText|}}
            {{#if bannerText}}
              <ExternalBillingBanner @bannerText={{bannerText}} />
            {{/if}}
          {{/let}}
        {{/if}}
        <BalanceBanner @client={{@client}} />
        <BillingAndPaymentsTabs />
        {{yield}}
      </Container>
    </BillingPage>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
